export const CONDITION_BY_TYPE = {
  entity_condition: 'entity_condition',
  entity_feature_condition: 'entity_feature_condition',
  regexp_condition: 'regexp_condition',
};

export const ACTION_BY_TYPE = {
  mark_action: 'mark_action',
  unmark_action: 'unmark_action',
  shift_action: 'shift_action',
  fill_action: 'fill_action',
};

export const ENTITY_W = 'W';
export const ENTITY_ANY = 'ANY';
export const SPECIAL_ENTITIES_NAMES = [ENTITY_W, ENTITY_ANY];
